module.exports = __webpack_public_path__ + "static/media/018.80a33398.jpg";